import React, { useEffect, useMemo, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  BoxProps, useMediaQuery,
} from "@chakra-ui/react";
import {FormattedMessage} from "react-intl";

function APResultDialog({
  children,
  open,
  title,
  onNext,
  footer,
  footerJustifyContent,
}: {
  children: any;
  open: boolean;
  title: string;
  onNext?: any;
  footer?: React.ReactNode;
  footerJustifyContent?: BoxProps["justifyContent"];
}) {
  const [isOpen, setOpen] = useState(false);
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const onContinue = () => {
    onNext();
  };

  const renderFooter = useMemo(() => {
    if (footer) {
      return footer;
    } else {
      return (
        <Button
          variant={"solid"}
          sx={{
            bg: "cyan.550",
            color: "white",
            boxShadow: "0px 4px 0 0 #3398a4",
            border: "1px solid #51b6c2",
            "&:hover": {
              bg: "#6bc1cb",
            },
            "&:focus": {},
            padding: isLargeScreen ? "0px 44px" : "0px 35px",
            minHeight: isLargeScreen ? "56px" : "45px",
            fontSize: isLargeScreen ? "1.26rem" : "1rem"
          }}
          onClick={() => onContinue()}
        >
          <FormattedMessage id="continue-button" defaultMessage={"Continuer"}/>
        </Button>
      );
    }
  }, [footer, onContinue]);

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
      >
        <ModalOverlay>
          <ModalContent
            sx={{
              width: { base: "calc(100% - 48px)", md: "100%" },
              maxWidth: isLargeScreen ? "36rem" : "28rem"
            }}
          >
            <ModalHeader className="result-dailog-header">
              <Box
                sx={{
                  marginTop: isLargeScreen ? "-60px" : "-47px",
                  marginBottom: isLargeScreen ? "12px" : "10px",
                }}
              >
                <img src={`${process.env.REACT_APP_BASE_URL}/flamme.png`} style={{width: isLargeScreen ? "80px" : "64px"}} />
              </Box>
              <div className="result-title" style={{fontSize: isLargeScreen ? "1.6rem" : "1.25rem"}}>{title}</div>
            </ModalHeader>
            <ModalBody className="ap-dialog-body">{children}</ModalBody>

            <ModalFooter className="ap-dialog-footer">
              {renderFooter}
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
}

export default APResultDialog;
